<template>
	<div id="app">
    
    <div class="content">
      <div class="custom-navigation">
        <NavBar  v-bind:apiresourceurl="apiresourceurl" />
        <NavFilters v-if="poi && subcategories" v-bind:clearfields="clearfields" v-bind:filteresult="filteresult" v-bind:tipaccesibil="tipaccesibil" v-bind:categories="categories" v-bind:subcategories="subcategories" v-on:changecategories="changeCategories"  v-on:clearselectedfields="clearSelectedFields"/>

      <b-collapse id="collapse-8" class="mt-2">
        <b-card class="politica" no-body >
          <div>
              <p>La Harta Accesibilitatii (accesibil.org) credem &icirc;n a fi transparenți și deschiși &icirc;n legătură cu modul &icirc;n care colectăm și utilizăm datele cu caracter personal ale dumneavoastră. &Icirc;n spiritul transparenței, această politică furnizează informații detaliate despre cum și c&acirc;nd utilizăm modulele cookie. Prezenta politică referitoare la modulele cookie se aplică pentru serviciile oferite exclusiv pe porțiunile publice disponibile ale website-ului, &icirc;n sensul acordării posibilității beneficiarului să acceseze serviciile folosind mijloace exclusiv electronice, incluz&acirc;nd și alte mijloace de comunicare la distanță (inclusiv telefonic) care se leagă de această politică sau care o &icirc;ncorporează prin referință.</p>
              <p>Harta Accesibilitatii (accesibil.org) se angajează să vă protejeze cu privire la colectarea online a oricăror date despre dumneavoastră.&nbsp;Această secțiune vă spune cum folosim modulele cookie, de ce, și modul &icirc;n care acest lucru ne permite să &icirc;mbunătățim serviciile.&nbsp;De asemenea, vă spune cum puteți gestiona modulele cookie care sunt stocate pe dispozitiv.</p>
              <p><strong>Harta Accesibilitatii (accesibil.org)</strong>&nbsp;<strong>folosește module cookie?</strong></p>
              <p>Folosim cookies pentru a &icirc;mbunătăți utilizarea și funcționalitatea website-ului nostru și pentru a &icirc;nțelege mai bine modul &icirc;n care vizitatorii utilizează website-ul accesibil.org, precum și serviciile oferite de către website.&nbsp;Prin accesarea sau utilizarea &icirc;n continuare a serviciilor noastre (prin orice dispozitiv), dumneavoastră declarați că sunteți de acord cu utilizarea modulelor cookie și a altor tehnologii similare &icirc;n scopurile specificate &icirc;n această politică.</p>
              <p>Dacă nu sunteți de acord cu modul nostru de utilizare a modulelor cookie, trebuie să setați corespunzător setările browserului dumneavoastră sau să nu utilizați acest website sau alte website-uri partenere.</p>
              <p>Dezactivarea modulelor cookie pe care le utilizăm ar putea afecta experiența dumneavoastră ca utilizator pe acest website și alte website-uri partenere. Ne rezervăm dreptul de a face modificări la Politica privind modulele cookie.&nbsp;Toate modificările vor apărea aici și intră &icirc;n vigoare imediat.&nbsp;Utilizarea &icirc;n continuare a website-ului nostru semnifică acordul dumneavoastră cu privire la orice astfel de modificări.</p>
              <p><strong>&nbsp;Ce este un modul cookie?</strong></p>
              <ul>
              <li>Un modul cookie este o colecție de date &icirc;ntr-un standard industrial pe care o pagină web le transferă pe computerul dumneavoastră, temporar, pentru a permite adaptarea conținutului la utilizator. &Icirc;n acest scop, modulele cookie colectează informații cu privire la comportamentul dumneavoastră online.</li>
              <li>Un modul cookie este un&nbsp;<strong>fișier</strong>de mici dimensiuni care conține un text alcătuit dintr-un șir de litere și cifre (informații), deseori codificate, care vă identifică &icirc;n mod unic computerul, terminalul mobil sau alte echipamente ale unui utilizator de pe care se accesează internetul, dar poate conține și alte informații. Un modul cookie este format din două părți: numele și conținutul sau valoarea modulului cookie. Durata de existență a unui modul cookie este determinată.</li>
              <li>Un modul cookie este un fișier care&nbsp;<strong>este</strong><strong>plasat/descărcat pe dispozitivul</strong>&nbsp;pe care &icirc;l utilizați atunci c&acirc;nd accesați un website, prin solicitarea emisă de către web server unui browser (ex.: Internet Explorer, Google Chrome), care permite utilizarea funcționalităților&nbsp;<a href="http://accesibil.org">ro</a>&nbsp;&icirc;nregistr&acirc;nd navigarea website-ului, astfel &icirc;nc&acirc;t, atunci c&acirc;nd accesați din nou website-ul, acesta poate prezenta opțiuni adaptate pe baza informațiilor stocate despre ultima dumneavoastră vizită.</li>
              <li>Un modul cookie este complet &bdquo;pasiv&rdquo; (nu conține programe software, viruși &ndash;&nbsp;<em>modulele cookie folosesc formate tip plain text, nu sunt alcătuite din bucăți de cod așa că nu pot fi executate și nici nu pot auto-rula; nu se pot duplica sau replica pe alte rețele pentru a se rula sau replica din nou</em>&ndash; sau spyware și nu poate accesa informațiile de pe hard disk-ul utilizatorului), ele permiț&acirc;nd exclusiv str&acirc;ngerea de informații despre comportamentul utilizatorilor&nbsp;<em>(&icirc;n principiu, care anume pagini web vizitează și c&acirc;nd)</em>.</li>
              <li>Altfel spus, modulul cookie poate fi văzut ca un card de identificare a utilizatorului de Internet, care anunță website-ul de fiecare dată c&acirc;nd utilizatorul se &icirc;ntoarce pe respectivul website.</li>
              </ul>
              <p><strong>&nbsp;De ce sunt modulele cookie importante pentru Internet</strong>?</p>
              <p>Modulele cookie reprezintă punctul central al funcționării eficiente a Internetului, ajut&acirc;nd la generarea unei experiențe de navigare prietenoase și adaptată preferințelor și intereselor fiecărui utilizator. Refuzarea sau dezactivarea modulelor cookie poate face unele website-uri imposibil de folosit.</p>
              <p>Exemple de &icirc;ntrebuințări importante ale modulelor cookie (care nu necesită autentificarea unui utilizator prin intermediul unui cont):</p>
              <ul>
              <li>Conținut și servicii adaptate preferințelor utilizatorului;</li>
              <li>Reținerea parolelor, preferințele de limbă (de exemplu: afișarea rezultatelor căutărilor &icirc;n limba Rom&acirc;nă);</li>
              <li>Reținerea filtrelor de protecție a copiilor privind conținutul pe Internet (opțiuni family mode, funcții de safe search);</li>
              <li>Limitarea frecvenței de difuzare a reclamelor &ndash; limitarea numărului de afișări a unei reclame pentru un anumit utilizator pe un website;</li>
              <li>Furnizarea de publicitate mai relevantă pentru utilizator;</li>
              <li>Măsurarea, optimizarea și caracteristicile de analytics &ndash; cum ar fi confirmarea unui anumit nivel de trafic pe un website, ce tip de conținut este vizualizat și modul cum un utilizator ajunge pe un website (ex. prin motoare de căutare, direct, din alte website-uri etc). Website-urile derulează aceste analize a utilizării lor pentru a &icirc;mbunătăți website-urile &icirc;n beneficiul userilor.</li>
              </ul>
              <p><strong>&nbsp;Scopul modulelor cookie</strong></p>
              <p>Modulele cookie pot asigura o&nbsp;<strong>interacțiune mai rapidă și mai ușoară &icirc;ntre utilizatori și website-uri</strong>.&nbsp;<em>Spre exemplu</em>, &icirc;n momentul autentificării unui utilizator pe un anumit website, datele de autentificare sunt stocate &icirc;ntr-un modul cookie; ulterior, utilizatorul poate accesa respectivul website fără să fie nevoie să se autentifice din nou.</p>
              <p>&Icirc;n alte cazuri, modulele cookie pot fi utilizate pentru&nbsp;<strong>stocarea de informații referitoare la activitățile desfășurate de utilizator pe o anumită pagină web</strong>, astfel &icirc;nc&acirc;t acesta să &icirc;și poată relua ușor respectivele activități la o accesare ulterioară a website-ului. Modulele cookie spun serverului ce pagini trebuie să arate utilizatorului, astfel &icirc;nc&acirc;t acesta să nu fie nevoit să &icirc;și amintească acest lucru sau să navigheze &icirc;ntregul website de la &icirc;nceput. Astfel, modulele cookie pot fi asimilate unor&nbsp;<em>&bdquo;semne de carte&rdquo;</em>&nbsp;care &icirc;i spun utilizatorului exact unde a rămas &icirc;n cadrul unui website.</p>
              <p><strong>Ce tipuri de module cookie utilizăm?</strong></p>
              <p>Noi utilizăm exclusiv module cookie de sesiune, proprii și instalate de terțe părți.</p>
              <p>Modulele cookie de sesiune sunt active numai pe durata unei sesiuni (de regulă, vizita obișnuită pe un website sau sesiunea unui browser).</p>
              <table width="779">
              <tbody>
              <tr>
              <td width="312">
              <p><strong>Categorii de utilizare</strong></p>
              </td>
              <td width="312">
              <p><strong>Descriere</strong></p>
              </td>
              </tr>
              <tr>
              <td width="312">
              <p><strong>Siguranță/Securitate</strong></p>
              </td>
              <td width="312">
              <p>Noi utilizăm module cookie ca să activăm și să sprijinim funcționalitățile noastre de siguranță, precum și ca să detectăm activități dăunătoare sau &icirc;ncălcări ale Acordului utilizatorului. Folosim module cookie pentru a detecta fraudele și utilizarea abuzivă a website-urilor și a serviciilor noastre.</p>
              </td>
              </tr>
              <tr>
              <td width="312">
              <p><strong>Preferințe, funcționalități și servicii</strong></p>
              </td>
              <td width="312">
              <p>Modulele cookie salvează preferințele, cum ar fi browserul și setările de player multimedia, astfel &icirc;nc&acirc;t să nu fie necesar să fie resetate de fiecare dată c&acirc;nd vă &icirc;ntoarceți la website.</p>
              </td>
              </tr>
              <tr>
              <td width="312">
              <p><strong>Performanță, analize și cercetare/Statistici</strong></p>
              </td>
              <td width="312">
              <p>Harta Accesibilitatii (accesibil.org) utilizează module cookie pentru echilibrarea &icirc;ncărcăturii, pentru a se asigura că website-urile răm&acirc;n &icirc;n stare de funcționare.</p>
              <p>Pentru a vă furniza serviciile noastre, folosim module cookie și alți identificatori pentru a colecta date despre utilizare și performanță.&nbsp;<em>De exemplu</em>, folosim modulele cookie pentru a contoriza numărul de vizitatori unici ai unei pagini web sau ai unui serviciu și pentru a crea alte statistici despre operațiunile produselor noastre.</p>
              </td>
              </tr>
              </tbody>
              </table>
              <p><strong>C&acirc;nd&nbsp;se plasează</strong>&nbsp;<strong>modulele cookie?</strong></p>
              <p>Toate browserele care accesează acest website vor primi module cookie de la noi. Plasăm, de asemenea, module cookie &icirc;n browser atunci c&acirc;nd accesați website-uri care nu folosesc module cookie și care ne găzduiesc plugin-urile (de exemplu, butonul &bdquo;Distribuiți&rdquo; de pe Faebook) sau etichetele.</p>
              <p><strong>Care este durata de viață a unui modul cookie?</strong></p>
              <p>Durata de viață a unui modul cookie poate varia semnificativ, depinz&acirc;nd de scopul pentru care este plasat. Modulele noastre cookie sunt per sesiune si expira la &icirc;nchiderea sesiunii. Durata de viață a unui modul cookie nu &icirc;i este impusă niciunui utilizator. Ele pot fi blocate sau șterse &icirc;n orice moment prin intermediul setărilor browserului.</p>
              <p><strong>Conțin modulele cookie date personale/Ce tip de informații sunt stocate și accesate prin intermediul modulelor cookie?</strong></p>
              <p>Modulele cookie &icirc;n sine nu solicită și nu dețin date cu caracter personal.&nbsp;<u>Ele nu pot identifica personal un utilizator de internet</u>. Datele personale pot fi colectate prin utilizarea modulelor cookie doar pentru a facilita anumite funcționalități pentru utilizator, &icirc;mbunătățind experiența de navigare pe Internet<em>.</em></p>
              <p>Pentru detalii legate de prelucrarea datelor dumneavoastră cu caracter personal, vă rugăm să consultați&nbsp;Politica de confidențialitate. &Icirc;n cazul &icirc;n care un modul cookie prelucrează date cu caracter personal, ne vom asigura că prelucrarea se va face &icirc;n conformitate cu legislația &icirc;n vigoare și cu Regulamentul (UE) nr. 679/2016 (GDPR).</p>
              <p><strong>Ce sunt modulele cookie plasate de terți?&nbsp;<em>(&bdquo;third party cookies&rdquo;)</em></strong></p>
              <p>&Icirc;n afară de modulele cookie pe care&nbsp;<a href="http://accesibil.org">accesibil.org</a>&nbsp;le creează atunci c&acirc;nd vizitați website-ul nostru, și terții pot să creeze module cookie &icirc;n timp ce vizitați website-urile terților.</p>
              <p>Deoarece browserul dumneavoastră se conectează la serverele web ale acestor terți pentru a prelua conținutul, terții respectivi pot crea sau citi propriile modulele cookie de pe dispozitivul dumneavoastră și pot să colecteze informații despre activitățile dumneavoastră online, pe diferite website-uri sau servicii online. Terțele părți/Furnizorii terți trebuie să respecte de asemenea legea &icirc;n vigoare și politicile de confidențialitate ale deținătorului (proprietarului) website-ului.</p>
              <p><strong>Controlul modulelor cookie</strong></p>
              <p>&Icirc;n general, o aplicație folosită pentru accesarea paginilor web permite salvarea modulelor cookie pe terminal &icirc;n mod implicit. Aceste setări pot fi schimbate &icirc;n așa fel &icirc;nc&acirc;t administrarea automată a modulelor cookie să fie blocată de browserul web sau utilizatorul să fie informat de fiecare dată c&acirc;nd modulele cookie sunt trimise către terminalul său. Informații detaliate despre posibilitățile și modurile de administrare a modulelor cookie pot fi găsite &icirc;n zona de setări a aplicației (browser-ului web). Limitarea folosirii modulelor cookie poate afecta anumite funcționalități ale paginii web. De asemenea, este posibil ca aceasta să vă &icirc;mpiedice să salvați setările dumneavoastră personalizate, cum ar fi informațiile de intrare &icirc;n cont.</p>
              <p>Instrucțiunile pentru blocarea sau ștergerea modulelor cookie din browsere pot fi disponibile &icirc;n documentația fiecărui browser privind confidențialitatea sau de ajutor.</p>
              <p><strong>Ce aveți de făcut dacă nu doriți setarea modulelor cookie sau dacă doriți eliminarea acestora?</strong></p>
              <p>Dacă nu doriți să acceptați module cookie, puteți, de asemenea, să modificați setările browserului pe computerul dumneavoastră sau pe alte dispozitive utilizate ca să accesați serviciile noastre. Majoritatea browserelor asigură de asemenea funcţionalitatea care vă permite să analizați și să ștergeți module cookie.&nbsp;<strong>Website-ul&nbsp;</strong><a href="http://accesibil.org"><strong>accesibil.org</strong></a><strong>&nbsp;nu va funcționa adecvat fără module cookie.</strong></p>
              <p>Producătorii de browsere asigură pagini de asistență privind gestionarea modulelor cookie &icirc;n produsele lor. Pentru mai multe informații, vizualizați mai jos.</p>
              <ul>
              <li><a href="https://support.google.com/chrome/answer/95647?hl=en-GB">Google Chrome</a></li>
              <li><a href="https://support.microsoft.com/en-us/help/260971/description-of-cookies">Internet Explorer</a></li>
              <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/kb/PH5042?locale=en_US">Safari (Desktop)</a></li>
              <li><a href="https://support.apple.com/en-us/HT201265">Safari (Mobile)</a></li>
              <li><a href="https://support.google.com/nexus/answer/54068?visit_id=1-636574272900572413-4122810037&amp;hl=en&amp;rd=1">Browser Android</a></li>
              <li><a href="https://www.opera.com/help">Opera</a></li>
              <li><a href="https://www.opera.com/help/mobile/android#privacy">Opera Mobile</a></li>
              </ul>
              <p>Pentru alte browsere, vă rugăm să consultați documentația furnizată de producătorul browserului.</p>
              <p>Pentru a afla mai multe despre modulele cookie, inclusiv&nbsp;<strong>cum să vizualizați tipurile de module cookie care au fost instalate și cum să le administrați și să le ștergeți</strong>, vizitați&nbsp;<a href="https://ro.wikipedia.org/wiki/Cookie">wikipedia.org</a>.</p>
              <p><strong>&nbsp;Modalități concrete de ștergere a modulelor cookie</strong>:</p>
              <ol>
              <li><strong>Pe computer</strong></li>
              </ol>
              <p><strong>&nbsp;Browserul Apple Safari</strong>: Secțiunea &bdquo;Confidentiality&rdquo; (confidențialitate) din meniul &laquo;Preferences&raquo; (preferințe), secțiunea prevăzută pentru &bdquo;Modul cookies and other data of Internet websites&rdquo; (modul cookie și alte date provenite de la website-uri).</p>
              <p><strong>Browserul Google Chrome</strong>: Secțiunea &bdquo;Confidentiality&rdquo; (confidențialitate) din meniul &laquo;Parameters&raquo; (parametri), subsecțiunea &laquo;Content Parameters&raquo; (parametri de conținut), secțiunea prevăzută pentru &laquo;Modul cookies and website data&raquo; (modul cookie și date provenite de la website-uri).</p>
              <p><strong>Browserul Microsoft Internet Explorer</strong>: Meniul &bdquo;Tools&rdquo; (instrumente), apoi secțiunea &bdquo;Internet Options&rdquo; (opțiuni de internet), &bdquo;General&rdquo; (generalități), &bdquo;Browser history&rdquo; (istoric al browserului), &bdquo;Parameters&rdquo; (parametri), apoi deschideți fereastra &bdquo;Parameters of temporary internet files and history&rdquo; (parametri ai fișierelor temporare de internet și ai istoricului) și &icirc;n final &bdquo;Display files&rdquo; (afișare a fișierelor).</p>
              <p><strong>Browserul Mozilla Firefox</strong>: Meniul &bdquo;Tools&rdquo; (instrumente), secțiunea &bdquo;Opțiuni&rdquo; (opțiuni), subsecțiunea &bdquo;Privacy&rdquo; (confidențialitate), funcționalitatea &bdquo;Delete specific modul cookies&rdquo; (ștergerea modulelor ookie specifice).</p>
              <ol start="2">
              <li><strong> Pe smartphone sau tabletă</strong></li>
              </ol>
              <p>Puteți să dezinstalați aceste module cookie folosind următoarele metode:</p>
              <p><strong>Browser Android</strong>: Deschideți ecranul &bdquo;Home&rdquo; (pagina de pornire), atingeți pictograma browserului web, atingeți butonul &bdquo;Menu&rdquo; (meniu), atingeți &bdquo;Settings&rdquo; (setări). Dispozitivul vă va transfera la un meniu cu setările disponibile SAU va avea una din cele trei opțiuni următoare. Atingeți opțiunea și veți avea: Privacy &amp; Security (confidențialitate și securitate), Privacy (confidențialitate), opțiunea Security (securitate), atingeți &bdquo;Clear Cache&rdquo; (golire cache), atingeți &bdquo;OK&rdquo; pentru a confirma, atingeți &bdquo;Clear all cookie data&rdquo; (ștergerea tuturor datelor modulelor cookie), atingeți &bdquo;OK&rdquo; pentru a confirma. Faceți clic pe butonul &bdquo;Home&rdquo; (pagina de pornire) pentru a reveni la ecranul &bdquo;Home&rdquo; (pagina de pornire). Reporniți dispozitivul oprindu-l și pornindu-l din nou.</p>
              <p><strong>Browser Google Chrome</strong>: &Icirc;n bara de instrumente a browserului, faceți clic pe &bdquo;the Chrome menu&rdquo; (meniul Chrome), apoi faceți clic pe &bdquo;More tools&rdquo; (mai multe instrumente) și &bdquo;Clear browsing data&rdquo; (ștergerea datelor de navigare). &Icirc;n caseta care apare, faceți clic pe casetele de selectare pentru &bdquo;cookies and other website and plug-in data&rdquo; (module cookie și alte date ale website-ului și plug-in-ului) și &bdquo;Cached images and files&rdquo; (imagini și fișiere memorate &icirc;n cache). Folosiți meniul din partea de sus pentru a selecta volumul de date pe care doriți să &icirc;l ștergeți. Alegeți &bdquo;beginning of time&rdquo; (de la &icirc;nceput) pentru a șterge totul. Faceți clic pe &bdquo;Clear browsing data&rdquo; (ștergerea datelor de navigare).</p>
              <p><strong>Apple iOS 8 sau versiuni mai noi</strong>: Faceți clic pe butonul &bdquo;Home&rdquo; (pagina de pornire), atingeți butonul &bdquo;Settings&rdquo; (setări), derulați &icirc;n jos p&acirc;nă la &bdquo;Safari&rdquo;, atingeți &bdquo;Clear History and Website Data&rdquo; (ștergerea istoricului și a datelor website-urilor). Veți primi un mesaj de avertizare. Atingeți &bdquo;Clear History and Data&rdquo; (ștergerea istoricului și a datelor) pentru a confirma. Faceți clic pe butonul &bdquo;Home&rdquo; (pagina de pornire) pentru a reveni la ecranul &bdquo;Home&rdquo; (pagina de pornire). Reporniți dispozitivul oprindu-l și pornindu-l din nou.</p>
              <p><strong>Foarte important</strong>: Procedura de ștergere a modulelor cookie poate diferi &icirc;n funcție de versiunea de software. Pentru mai multe detalii contactați operatorul de software &icirc;n funcție de problemele pe care le &icirc;nt&acirc;mpinați.</p>
              <p><strong>Sfaturi pentru o navigare sigură și responsabilă, bazată pe module cookie</strong></p>
              <p>Datorită flexibilității lor și a faptului că majoritatea dintre cele mai vizitate website-uri și cele mai mari folosesc module cookie, acestea sunt aproape inevitabile. Dezactivarea modulelor cookie nu va permite accesul utilizatorului pe website-urile cele mai răsp&acirc;ndite și utilizate.</p>
              <p>Iată c&acirc;teva sfaturi care vă pot asigura că navigați fără griji &icirc;nsă cu ajutorul modulelor cookie:</p>
              <ul>
              <li>Particularizați-vă setările browserului &icirc;n ceea ce privește modulele cookie pentru a reflecta un nivel confortabil pentru voi al securității utilizării modulelor cookie.</li>
              <li>Dacă &icirc;mpărțiți accesul la dispozitiv, puteți lua &icirc;n considerare setarea browserului pentru a șterge datele individuale de navigare de fiecare dată c&acirc;nd &icirc;nchideți browserul. Aceasta este o variantă de a accesa website-urile care plasează modulele cookie și de a șterge orice informație de vizitare la &icirc;nchiderea sesiunii navigare.</li>
              <li>Instalați-vă și updatați-vă constant aplicații anti-spyware.</li>
              </ul>
              <p>Multe dintre aplicațiile de detectare și prevenire a spyware-ului includ detectarea atacurilor pe website-uri. Astfel, &icirc;mpiedică browserul de la a accesa website-uri care ar putea să exploateze vulnerabilitățile browserului sau să descarce software periculos.</p>
              <p>Asigurați-vă că aveți browserul mereu actualizat la ultimele versiuni disponibile.</p>
              <p>Multe dintre atacurile bazate pe module cookie se realizează exploat&acirc;nd punctele slabe ale versiunilor vechi ale browserelor.</p>
              <p>Modulele cookie sunt pretutindeni și nu pot fi evitate dacă doriți să vă bucurați de acces pe cele mai bune și cele mai mari website-uri de pe Internet &ndash; locale sau internaționale. Cu o &icirc;nțelegere clară a modului lor de operare și a beneficiilor pe care le aduc, puteți lua măsurile necesare de securitate astel &icirc;nc&acirc;t să puteți naviga cu &icirc;ncredere pe internet.</p>
              <p>Dezactivarea și refuzul de a primi module cookie pot face anumite website-uri impracticabile sau dificil de vizitat și folosit.</p>
              <p>Este posibilă setarea din browser pentru ca aceste module cookie să nu mai fie acceptate sau poți seta browserul să accepte module cookie de la un website anume.</p>
              <p>Toate browserele moderne oferă posibilitatea de a schimba setările modulelor cookie. Aceste setări se găsesc de regulă &icirc;n &bdquo;opțiuni&rdquo; sau &icirc;n meniul de &bdquo;preferințe&rdquo; al browserului dumneavoastră.</p>
          </div>
        


          <b-button v-b-toggle.collapse-8 size="sm">Inchide</b-button>

        </b-card>
      </b-collapse>

      </div>
      


      <div class="map-handles column" id="map_buttons">
          <img @click="setmapCenter(maplat, maplng)" id="map-locate"  src="./assets/map-locate-button.png">
          <img @click="zoomin" id="mapzoomin" src="./assets/map-zoom-in-button.png">
          <img @click="zoomout" id="map-zoom-out" src="./assets/map-zoom-out-button.png">
       </div>
       <FilterList v-bind:isfilteractive="isfilteractive" v-bind:poi="poi" v-on:setCenterForMarker="setfiltercenter"/> 
       <div ref="sidebarcontainer" class="sidebar">
         <SideBar v-bind:apiresourceurl="apiresourceurl" v-bind:pk="parseInt(pk)" v-show="isVisible" v-on:closehide="hideSideBar" />
       </div>
    

		<div id="map" ref="map" style="height:-webkit-fill-available;height:100%;">
      <div v-for="(p, pk) in poi" :key="pk" id="allmarkersdiv">
          <div :ref="p.tipaccesibil" v-if="allmarkersdivVisible">
              <map-marker v-if="p.ismarkervisible" v-bind:lat="Number(p.lat)" v-bind:lng="Number(p.lng)" v-bind:icon="p.icon" v-bind:pk="p.pk" v-on:elementclick="changediv"></map-marker>
          </div>

          
      </div>
		</div>
   </div>
  <footer>
    <cookie-law theme="blood-orange" buttonText="Accepta">
        <div slot="message">
            Acest site web folosește cookie-uri pentru a vă îmbunătăți experiența. Mai multe detalii <b-link v-b-toggle.collapse-8>Polica Cookie</b-link>
        </div>

    </cookie-law>
  </footer>



	</div>
</template>

<script>
  import Vue from 'vue';
  import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
  import 'bootstrap/dist/css/bootstrap.css';
  import 'bootstrap-vue/dist/bootstrap-vue.css';
  import CookieLaw from 'vue-cookie-law'
  import SideBar from './components/SideBar.vue'
  import NavBar from './components/NavBar'
  import NavFilters from './components/NavFilters'
  import MapMarker from "./components/MapMarker"
  import FilterList from "./components/FilterList"
  import axios from 'axios'
  import initpoi from './data/initpoi.json'
  Vue.use(BootstrapVue);
  Vue.use(BootstrapVueIcons);
	export default {    
		components: {
      MapMarker,
      NavBar,
      NavFilters,
      SideBar,
      CookieLaw,
      FilterList
		},
		data: () => ({
      isVisible: false,
      apiresourceurl: "https://sv4api.accesibil.org",
			map: null,
      poi: initpoi,
      poifiltered: null,
      poidata: [],
      categories: null,
      subcategories: null,
      searchkey: '',
      pk: 1,
      infoseen: true,
      location:null,
      gettingLocation: false,
      errorStr:null,
      allmarkersdivVisible:true,
      tipaccesibil: ["Accesibil", "Moderat Accesibil", "Inaccesibil"],
      filteresult: 0,
      clearfields: false,
      isfilteractive: false,
      markercount: 0,
      maplat: 45.814017,
      maplng: 24.765873,
      mapzoom: 7,
      cookieoverlay: false
      
		}),
		methods: {
			getMap(callback) {
				let vm = this
				function checkForMap() {
					if (vm.map) callback(vm.map)
					else setTimeout(checkForMap, 1000)
				}
				checkForMap()
      },
      setfiltercenter(value) {
        this.map.setCenter({lat:value.lat, lng:value.lng})
        this.map.setZoom(16)
      },
      setmapCenter(latitude, longitude)  {
        this.map.setCenter({lat:latitude, lng:longitude})
        this.map.setZoom(this.mapzoom)
      },
      zoomout() {
        this.map.setZoom(this.map.getZoom() - 1);
      },
      zoomin() {
        this.map.setZoom(this.map.getZoom() + 1);
      },
      changediv(value) {
          this.pk = value
          this.isVisible = true
      },
      hideSideBar() {
        this.isVisible = false
      },
      makeMarkerinvisible () {
        this.allmarkersdivVisible = false
      },
      makeMarkervisible () {
        
        this.allmarkersdivVisible = true
      },
      cleafilterfields () {
        this.clearfields = true
        this.allmarkersdivVisible = true
        this.isfilteractive == false
        this.filteresult = 0
      },
      clearSelectedFields () {
        this.allmarkersdivVisible = true
        this.poi.forEach( function (p) {            
             p.ismarkervisible = true
         })
        this.filteresult = this.markercount
        this.isfilteractive == false
        this.donechanges === true
      },            
      changeCategories(value) {
        this.allmarkersdivVisible = true
        this.filteresult = 0
        this.searchkey = value['keyword']
        let key = this.searchkey.toLowerCase()
        this.isfilteractive = true
        this.poi.forEach( function (p) {            
             p.ismarkervisible = false
         })          
          this.poi
            .filter(function (p){
              return p.nume.toLowerCase().includes(key);
            })
            .filter(function(p){
              return value["categories"].length == 0 ? true : value["categories"].includes(p.categorie);
            })
            .filter(function(p){
              return value["subcategories"].length == 0 ? true : value["subcategories"].includes(p.subcategorie);
            })
            .filter(function(p){
              return value["tipaccesibil"].length == 0 ? true : value["tipaccesibil"].includes(p.tipaccesibil);
            })  
            .forEach(entry => {              
              entry.ismarkervisible = true
              this.filteresult += 1
            })
      },
      async fetchdata() {

        await axios
          .get(`${this.apiresourceurl}/poi-all/`)
          .then(response => (this.poi = response.data))
          this.filteresult = this.poi.length
          this.markercount = this.poi.length

      }       
		},
		async mounted() {
      await axios
        .get(`${this.apiresourceurl}/categorie/`)
        .then(response => (this.categories = Object.freeze(response.data)))
      
      await axios
        .get(`${this.apiresourceurl}/subcategorie/`)
        .then(response => (this.subcategories = Object.freeze(response.data)))
      
      const styledMapType = new window.google.maps.StyledMapType(
            [
                {
                    "featureType": "water",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#b5cbe4"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "stylers": [
                        {
                            "color": "#efefef"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#83a5b0"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#bdcdd3"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e3eed3"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "lightness": 33
                        }
                    ]
                },
                {
                    "featureType": "road"
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {},
                {
                    "featureType": "road",
                    "stylers": [
                        {
                            "lightness": 20
                        }
                    ]
                }
            ],
          { name: "Styled Map" }
        );     

			this.map = await new window.google.maps.Map(this.$refs["map"], {
				center: { lat: this.maplat, lng: this.maplng },
				zoom: this.mapzoom,
        disableDefaultUI: true,
        gestureHandling: 'greedy'
      })
    //do we support geolocation
      if(!("geolocation" in navigator)) {
        this.errorStr = 'Geolocation is not available.';
        return;
      }
      this.map.mapTypes.set("styled_map", styledMapType);
      this.map.setMapTypeId("styled_map");
      this.gettingLocation = true;
      // get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false;
        this.location = pos;        
        this.setmapCenter(this.location.coords.latitude, this.location.coords.longitude);
        this.maplat = this.location.coords.latitude
        this.maplng = this.location.coords.longitude
        this.map.setZoom(12)
        this.mapzoom = 12
      }, err => {
        this.gettingLocation = false;
        this.errorStr = err.message;
      })
      this.$gtag.event('page_viewed', { method: 'Website' })
      await this.fetchdata()
		}
	}
</script>

<style scoped>
@media screen and (max-width: 992px) {
  .politica {
    max-width: 100%;
  }
}

@media screen and (min-width: 992px) {
  .politica {
    max-width: 80%;    
    margin: 0 auto
  }
}  



	#map {
		
		background: gray;
    position: relative;
    overflow: hidden;
    position: absolute; top: 0; right: 0; bottom: 0; left: 0;
	}
  div.column {
    display: flex;
    flex-direction: column;
  }
  div.map-handles {
    z-index: 5;
    position: absolute;
    right: 10px;
    float: right;
  }
  div.map-handles img {
    height: 47px;
    width: 47px;
  }
  div.content {
    background-color: red;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
.sidebar {
  position: relative;
}
.custom-navigation {
  z-index: 5;
  position: relative;
  background-color: #ffffff;
}


</style>
